import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './faq.css';

const faqData = [
  {
    id: "01",
    question: "How long does a typical enterprise deployment take?",
    answer: "Our standard deployment protocol ranges from 4 to 8 weeks depending on matrix complexity. This includes UI/UX architecture, full-stack engineering, and rigorous security audits before final edge deployment."
  },
  {
    id: "02",
    question: "Do you provide post-launch infrastructure support?",
    answer: "Yes. All builds come with a 30-day post-launch telemetry monitoring phase. We also offer extended retainer contracts for continuous server maintenance, security patches, and scaling optimizations."
  },
  {
    id: "03",
    question: "What security frameworks do you integrate?",
    answer: "We deploy enterprise-grade security layers including End-to-End Encryption (E2EE), JWT authentication protocols, DDoS mitigation via Cloudflare, and strict adherence to GDPR and CCPA data compliance standards."
  },
  {
    id: "04",
    question: "Can you integrate with our existing legacy databases?",
    answer: "Absolutely. We routinely build secure middleware APIs (GraphQL/REST) that allow modern, high-speed frontends to communicate flawlessly with legacy on-premise servers and SQL databases."
  }
];

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // AUTOMATED AEO/SEO SCHEMA GENERATOR
  // This creates the invisible data format that AI engines (Perplexity, Google SGE) crave.
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <section className="faq-terminal-section mt-5 mb-5">
      
      {/* Invisible SEO/AEO payload injected into the DOM */}
      <script 
        type="application/ld+json" 
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaMarkup) }} 
      />

      <Container className="faq-master-container">
        
        {/* Decorative Grid Lines */}
        <div className="faq-grid-overlay"></div>

        <Row className="justify-content-center position-relative" style={{ zIndex: 2 }}>
          <Col lg={10} xl={8}>
            
            <div className="faq-system-header text-center mb-5">
              <div className="d-flex justify-content-center align-items-center gap-2 mb-2">
                <span className="faq-pulse-dot"></span>
                <span className="faq-meta-tag">KNOWLEDGE_BASE // QUERY_INDEX</span>
              </div>
              <h2 className="faq-heading">FREQUENTLY ASKED QUERIES</h2>
              <p className="faq-sub-heading">
                Access our central intelligence repository. Select a parameter below to decrypt deployment specifications.
              </p>
            </div>

            <div className="faq-accordion-group">
              {faqData.map((faq, index) => {
                const isActive = activeIndex === index;
                
                return (
                  <div 
                    key={faq.id} 
                    className={`faq-data-node ${isActive ? 'node-active' : ''}`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-query-row">
                      <div className="faq-query-left">
                        <span className="faq-id-badge">SYS_{faq.id}</span>
                        <h4 className="faq-question-text">{faq.question}</h4>
                      </div>
                      <div className="faq-tactical-icon">
                        {isActive ? '[ - ]' : '[ + ]'}
                      </div>
                    </div>
                    
                    <div 
                      className="faq-answer-wrapper"
                      style={{ 
                        maxHeight: isActive ? '300px' : '0',
                        opacity: isActive ? 1 : 0
                      }}
                    >
                      <div className="faq-answer-content">
                        <div className="answer-tracer-line"></div>
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default FAQ;